export default () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const jwtToken = urlSearchParams.get('t');
    const key = jwtToken ? 't' : '';

    return { key, data: jwtToken }
}